<template>
  <div :style="'display: flex;width: 780px;'">
    <div class="form-column">
      <el-form class="result-form">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td class="header">{{ $t('FileHistory.fileName') }}</td>
            <td><span style="margin-left: 10px;">{{ details.fileName }}</span></td>
            <td class="header">{{ $t('SeaExport.BusinessReferenceNo') }}</td>
            <td><el-input v-model="resultJson.ourCompanyNo" no="ourCompanyNo" /></td>
          </tr>
          <tr>
            <td class="header">{{ $t('SeaExport.SerialNo') }}</td>
            <td><span style="margin-left: 10px;">{{ details.fileNo }}</span></td>
            <td class="header">{{ $t('SeaExport.BusinessNumber') }}</td>
            <td><span style="margin-left: 10px;">{{ details.jobNo }}</span></td>
          </tr>
          <tr>
            <td class="header">{{ $t('SeaExport.ConsignationCompany') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.client" no="1" @change="mapperClient" /></el-form-item>
                <cargo-company-select
                  no="2"
                  :method-params="{customer:true,companyLob:'seaExport',active:true}"
                  :default-value="job.customerId||''"
                  style="width: 150px;"
                  @change="p=>{job.customerId=p.value}"
                />
              </div>
            </td>
            <td class="header">{{ $t('SeaExport.WarehouseNo') }}</td>
            <td><el-input v-model="resultJson.warehouseReceiptNo" no="3" /></td>
          </tr>
          <tr>
            <td rowspan="7" class="header">{{ $t('Message.Shipper') }}</td>
            <td><el-form-item><el-input v-model="job.shipperLine1" no="4" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.BLForm') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.orderType" no="5" @change="mapperBlType" /></el-form-item>
                <el-select
                  v-model="job.orderType"
                  no="6"
                >
                  <el-option
                    v-for="(item,index) in blModeList"
                    :key="index"
                    :label="item.name"
                    :value="item.serialNumber"
                  />
                </el-select>
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine2" no="7" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.LCL') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.fclOrLcl" no="8" @change="mapperLoadType" /></el-form-item>
                <el-select v-model="job.containerLoadType" no="9">
                  <el-option
                    v-for="(item,index) in (containerLoadTypes)"
                    :key="index"
                    :label="isZh?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine3" no="10" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.ShippingCompany') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.shipName" no="11" @change="mapperShipName" /></el-form-item>
                <cargo-company-select
                  no="12"
                  :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                  :default-value="job.carrierId||''"
                  style="width: 150px;"
                  @change="p=>{job.carrierId=p.value}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine4" no="13" /></el-form-item></td>
            <td class="header">{{ $t('Payment.vessel') }}</td>
            <td><el-form-item><el-input v-model="resultJson.vessel" no="14" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine5" no="15" /></el-form-item></td>
            <td class="header">{{ $t('Payment.voyage') }}</td>
            <td><el-form-item><el-input v-model="resultJson.voyage" no="16" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine6" no="17" /></el-form-item></td>
            <td class="header">{{ $t('queryJob.dateOfDeparture') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.etd" no="18" @change="mapperEtd" /></el-form-item>
                <el-date-picker
                  no="19"
                  :value="job.etd"
                  type="date"
                  style="width: 150px;"
                  value-format="yyyy-MM-dd"
                  @input="etdChange"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.shipperLine7" no="20" /></el-form-item></td>
            <td colspan="2" />
          </tr>
          <tr>
            <td rowspan="7" class="header">{{ $t('Message.Consignee') }}</td>
            <td><el-form-item><el-input v-model="job.consigneeLine1" no="21" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.TransportationClause') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.serviceTerm" no="22" @change="mapperFreightTerm" /></el-form-item>
                <cargo-advance-select
                  no="23"
                  :select-type="selectTypeNames.basic_data_ShippingTerm"
                  filterable
                  :clearable="false"
                  :default-value="job.freightTerm"
                  style="width: 150px;"
                  @parentCallBack="p=>{job.freightTerm=p.value}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine2" no="24" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.FreightTerm') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.paymenTerm" no="25" @change="mapperPaymentTerm" /></el-form-item>
                <cargo-advance-select
                  no="26"
                  :select-type="selectTypeNames.basic_data_PaymentTerm"
                  filterable
                  :clearable="false"
                  :default-value="job.paymentTermMBL"
                  style="width: 150px;"
                  @parentCallBack="p=>{job.paymentTermMBL=p.value;}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine3" no="27" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.ContainerSize') }}</td>
            <td><el-form-item><el-input v-model="resultJson.boxType" no="28" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine4" no="29" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.ContainerAmount') }}</td>
            <td><el-form-item><el-input v-model="resultJson.boxVolume" no="30" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine5" no="31" /></el-form-item></td>
            <td class="header">{{ $t('queryJob.IncoTerm') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.deliveryTerm" no="32" @change="mapperIncoTerm" /></el-form-item>
                <cargo-advance-select
                  no="33"
                  :select-type="selectTypeNames.basic_data_IncoTerm"
                  filterable
                  :clearable="false"
                  :default-value="job.incoTerm"
                  style="width: 150px;"
                  @parentCallBack="p=>{job.incoTerm=p.value}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine6" no="34" /></el-form-item></td>
            <td class="header">{{ $t('Payment.contactPerson') }}</td>
            <td><el-form-item><el-input v-model="resultJson.contacts" no="35" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.consigneeLine7" no="36" /></el-form-item></td>
            <td colspan="2" />
          </tr>
          <tr>
            <td rowspan="7" class="header">{{ $t('Message.Notify') }}</td>
            <td><el-form-item><el-input v-model="job.notifyLine1" no="37" /></el-form-item></td>
            <td rowspan="7" class="header">{{ $t('SeaExport.CargoSize') }}</td>
            <td rowspan="7">
              <div style="position: relative;">
                <div v-if="!showGoods" style="cursor: pointer; position: absolute; top: 0; right: 0; color: deepskyblue; z-index: 1;" @click="onMultDoc()">{{ $t('SeaExport.MultipleMode') }}</div>
                <el-form-item><el-input v-model="resultJson.goodSize" type="textarea" resize="none" :rows="11" no="38" /></el-form-item>
              </div>
            </td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine2" no="39" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine3" no="40" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine4" no="41" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine5" no="42" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine6" no="43" /></el-form-item></td>
          </tr>
          <tr>
            <td><el-form-item><el-input v-model="job.notifyLine7" no="44" /></el-form-item></td>
          </tr>
          <tr>
            <td class="header">{{ $t('Payment.portOfLoading') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.portOfLoading" no="45" @change="mapperSeaPort('loadingPortCode', 'portOfLoading')" /></el-form-item>
                <cargo-advance-select
                  no="46"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.loadingPortCode"
                  tag-name="englishName"
                  style="width: 180px;"
                  @parentCallBack="p=>{job.loadingPortCode=p.value;}"
                />
              </div>
            </td>
            <td class="header">{{ $t('Payment.portOfTransfer') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.transitPort" no="47" @change="mapperSeaPort('transferPortCode', 'transitPort')" /></el-form-item>
                <cargo-advance-select
                  no="48"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.transferPortCode"
                  style="width: 180px;"
                  @parentCallBack="p=>{job.transferPortCode=p.value;}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="header">{{ $t('queryJob.dischargingPortCode') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.portOfDischarge" no="49" @change="mapperSeaPort('dischargingPortCode', 'portOfDischarge')" /></el-form-item>
                <cargo-advance-select
                  no="50"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.dischargingPortCode"
                  style="width: 180px;"
                  @parentCallBack="p=>{job.dischargingPortCode=p.value}"
                />
              </div>
            </td>
            <td class="header">{{ $t('queryJob.placeOfDelivery') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.placeOfDelivery" no="51" @change="mapperSeaPort('destinationPortCode', 'placeOfDelivery')" /></el-form-item>
                <cargo-advance-select
                  no="52"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.destinationPortCode"
                  style="width: 180px;"
                  @parentCallBack="p=>{job.destinationPortCode=p.value}"
                />
              </div>
            </td>
          </tr>
          <tr v-if="!showGoods">
            <td class="header">{{ $t('SeaExport.Quantity') }}</td>
            <td><el-form-item><el-input v-model="resultJson.numberOfPieces" no="53" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.Package') }}</td>
            <td>
              <div class="mapperClass">
                <el-form-item><el-input v-model="resultJson.packing" no="54" @change="mapperPacking" /></el-form-item>
                <cargo-packing-select :default-value="job.packing" style="width: 180px;" @change="p=>{job.packing=p.value}" />
              </div>
            </td>
          </tr>
          <tr v-if="!showGoods">
            <td class="header">{{ $t('SeaExport.Weight') }}</td>
            <td><el-form-item><el-input v-model="resultJson.grossWeight" no="55" /></el-form-item></td>
            <td class="header">{{ $t('SeaExport.Cubage') }}</td>
            <td><el-form-item><el-input v-model="resultJson.volume" no="56" /></el-form-item></td>
          </tr>
          <tr>
            <td class="header">{{ $t('SeaExport.Marks') }}</td>
            <td><el-form-item><el-input v-model="resultJson.marks" type="textarea" resize="none" :rows="10" no="57" /></el-form-item></td>
            <td class="header">{{ $t('Pricing.Goods') }}</td>
            <td><el-form-item><el-input v-model="resultJson.goodName" type="textarea" resize="none" :rows="10" no="58" /></el-form-item></td>
          </tr>
          <tr v-if="!showGoods">
            <td class="header">{{ $t('Payment.remarks') }}</td>
            <td colspan="3"><el-form-item><el-input v-model="resultJson.remarks" type="textarea" resize="none" :rows="5" no="59" /></el-form-item></td>
          </tr>
        </table>
        <!-- 货物信息 -->
        <div v-if="showGoods">
          <el-button :disabled="readOnly" type="primary" style="margin-top: 10px;" no="60" @click="addGoods()">{{ $t('Information.Add') }}</el-button>
          <el-button :disabled="readOnly" type="primary" no="61" @click="deleteGoods()">{{ $t('Information.Delete') }}</el-button>
          <el-button :disabled="readOnly" type="primary" no="62" @click="noExchange()">{{ $t('SeaExport.NumberExchange') }}</el-button>
          <el-button :disabled="readOnly" type="primary" no="63" @click="updateMode()">{{ $t('SeaExport.ReturnMode') }}</el-button>
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="goods.gridOptions"
            :column-defs="goodsColumnDefs"
            :row-data="goods.rowData"
            style="width:100%;height:200px;margin-top: 10px;"
            @gridReady="params=>{goods.gridApi=params.api}"
          />
        </div>
      </el-form>
    </div>
    <div v-if="showOtherField" class="section form-column" style="padding-top: 10px;">
      <el-form label-width="85px" label-position="right">
        <div style="padding-bottom: 15px;">
          <span>{{ $t('SeaExport.OcrOtherInfo') }}
            <el-popover
              placement="bottom"
              width="400"
              trigger="hover"
            >
              <div class="pop-content">{{ $t('SeaExport.OcrTip') }}</div>
              <svg-icon slot="reference" icon-class="question" style="font-size: 14px;margin-top: -3px;" />
            </el-popover>
          </span>
        </div>

        <el-form-item v-for="item in expressList" :key="item.name" :label="ColumnUtils.columnLabelFunc(SystemConstants.OCR_FIELDS, item.name)">
          <!-- 揽货类型-->
          <el-select
            v-if="item.name === 'cargoSource'"
            v-model="job.cargoSource"
            no="64"
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
            style="width: 150px;"
          >
            <el-option
              v-for="(item,index) in SystemConstants.CARGO_SOURCES"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
          <!-- 预计到货日期 warehouseInfo.arriveDate-->
          <el-date-picker
            v-if="item.name === 'arriveDate'"
            v-model="job.arriveDate"
            no="65"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 150px;"
          />
          <!-- 截关日期-->
          <el-date-picker
            v-if="item.name === 'customCutoff'"
            v-model="job.customCutoff"
            no="66"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 150px;"
          />
          <!-- 客户截关日期-->
          <el-date-picker
            v-if="item.name === 'customerCutoff'"
            v-model="job.customerCutoff"
            no="67"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 150px;"
          />
          <!-- 客户退关日期-->
          <el-date-picker
            v-if="item.name === 'customerShutout'"
            v-model="job.customerShutout"
            no="68"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 150px;"
          />
          <!-- 客户退关日期-->
          <el-date-picker
            v-if="item.name === 'customerFileCutoff'"
            v-model="job.customerFileCutoff"
            no="69"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 150px;"
          />
          <cargo-user-select
            v-if="item.name === 'csr'"
            ref="csr"
            no="70"
            :method-params="{category:'role',shape:'csr'}"
            :default-value="job.csr||''"
            :merge-load="true"
            style="width: 150px;"
            @change="p=>{csrChangeHandler(p)}"
          />
          <cargo-user-select
            v-if="item.name === 'dc'"
            ref="dc"
            no="71"
            :method-params="{category:'role',shape:'doc'}"
            :default-value="job.dc||''"
            :merge-load="true"
            style="width: 150px;"
            @change="p=>{dcChangeHandler(p)}"
          />
          <!-- 小件数-->
          <auto-number-input
            v-if="item.name === 'insideQuantity'"
            v-model="job.insideQuantity"
            no="72"
            :precision="0"
            :min="0"
            style="width: 150px;"
            @valCallBack="(val)=>{
              job.insideQuantity = val
            }"
          />
          <!-- 小件包装-->
          <cargo-packing-select
            v-if="item.name === 'insidePacking'"
            no="73"
            :default-value="job.insidePacking"
            style="width: 150px;"
            @change="p=>{job.insidePacking=p.value}"
          />
          <!-- 计费重量RT-->
          <div v-if="item.name === 'chargeWeight'" style="display: flex">
            <auto-number-input
              v-model="job.chargeWeight"
              no="74"
              :precision="3"
              :min="0"
              style="flex:1;width: 135px;"
              @valCallBack="(val)=>{
                job.chargeWeight = val
              }"
            />
            <span>M/T</span>
          </div>
          <el-input
            v-if="item.name === 'userDefinedField1'"
            v-model="job.userDefinedField1"
            no="75"
            type="textarea"
            :rows="5"
            style="width: 150px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),job.userDefinedField1,val=>{job.userDefinedField1=val})"
          />
          <el-input
            v-if="item.name === 'userDefinedField2'"
            v-model="job.userDefinedField2"
            no="76"
            type="textarea"
            :rows="5"
            style="width: 150px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),job.userDefinedField2,val=>{job.userDefinedField2=val})"
          />
          <el-input
            v-if="item.name === 'userDefinedField3'"
            v-model="job.userDefinedField3"
            no="77"
            type="textarea"
            :rows="5"
            style="width: 150px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),job.userDefinedField3,val=>{job.userDefinedField3=val})"
          />
          <el-input
            v-if="item.name === 'userDefinedField4'"
            v-model="job.userDefinedField4"
            no="78"
            type="textarea"
            :rows="5"
            style="width: 150px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField4'),job.userDefinedField4,val=>{job.userDefinedField4=val})"
          />
          <cargo-rich-textarea
            v-if="item.name === 'cargoChineseName'"
            v-model="job.cargoChineseName"
            no="cargoChineseName"
            :auto-uppercase="false"
            :auto-half-word="false"
            wrap-symbol="r"
            style="height: 110px"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val})"
          />
        </el-form-item>
        <el-form-item v-if="job.cargoSource === CargoSource.NC_CARGO_SOURCE.code" :label="$t('SeaExport.NCReferenceNo')">
          <el-input v-model="job.agentRefNo" no="agentRefNo" />
        </el-form-item>
      </el-form>
    </div>

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { CONTAINERLOAD_TYPES } from '@/class/cargo/model/parameters/ContainerLoadType'
import CargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import ColumnUtils from '@/utils/ColumnUtils'
import { getOcrList } from '@/api/ocrSet'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import StrUtils from '@/utils/StrUtils'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { deepClone } from '@/utils'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import DateUtils from '@/utils/dateUtils'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'

export default {
  name: 'ResultFormXhq',
  components: { CargoRichTextarea, AutoNumberInput, CargoUserSelect, CargoAdvanceSelect, CargoPackingSelect, cargoCompanySelect },
  props: {
    details: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      CargoSource,
      resultJson: {},
      containerLoadTypes: CONTAINERLOAD_TYPES,
      SystemConstants,
      ColumnUtils,
      selectTypeNames: TYPE_NAMES,
      smartTrustChannel: '',
      useCase: 0, // 0 海运出口 1 空运出口
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      },
      otherField: {},
      expressList: [],
      mapperTexts: [],
      showGoods: false, // 是否多单模式
      port: new Map(),
      carrier: new Map(),
      blType: new Map(),
      loadType: new Map(),
      shippingTerm: new Map(),
      paymentTerm: new Map(),
      incoTerm: new Map(),
      eq: new Map(),
      customer: new Map(),
      packing: new Map(),
      goods: {
        selectedRow: null,
        gridOptions: {
          singleClickEdit: true,
          rowSelection: 'single',
          suppressCellSelection: true,
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor
          },
          context: {
            componentParent: this
          },
          onRowClicked: event => { this.goods.selectedRow = event.data }
        },
        rowData: [],
        gridApi: null
      },
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ],
      job: {},
      initJob: {
        customerId: 0,
        containerLoadType: '',
        carrierId: 0,
        freightTerm: '',
        paymentTermMBL: '',
        incoTerm: '',
        etd: '',
        loadingPortCode: '',
        transferPortCode: '',
        dischargingPortCode: '',
        destinationPortCode: '',
        packing: '',
        orderType: '',
        shipperLine1: '',
        shipperLine2: '',
        shipperLine3: '',
        shipperLine4: '',
        shipperLine5: '',
        shipperLine6: '',
        shipperLine7: '',
        consigneeLine1: '',
        consigneeLine2: '',
        consigneeLine3: '',
        consigneeLine4: '',
        consigneeLine5: '',
        consigneeLine6: '',
        consigneeLine7: '',
        notifyLine1: '',
        notifyLine2: '',
        notifyLine3: '',
        notifyLine4: '',
        notifyLine5: '',
        notifyLine6: '',
        notifyLine7: '',
        cargoSource: '',
        arriveDate: '',
        customCutoff: '',
        customerCutoff: '',
        customerShutout: '',
        customerFileCutoff: '',
        csr: 0,
        csrDepartment: 0,
        csrOffice: 0,
        dc: 0,
        dcDepartment: 0,
        dcOffice: 0,
        insideQuantity: 0,
        insidePacking: '',
        chargeWeight: 0,
        userDefinedField1: '',
        userDefinedField2: '',
        userDefinedField3: '',
        userDefinedField4: '',
        cargoChineseName: '',
        agentRefNo: ''
      }
    }
  },
  computed: {
    readOnly() {
      return this.details && this.details.status === 3
    },
    showOtherField() {
      return this.expressList && this.expressList.length > 0
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isXhq() {
      return this.smartTrustChannel === 'xhq'
    },
    goodsColumnDefs() {
      return [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          colId: 'warehouseReceiptNo',
          field: 'warehouseReceiptNo',
          width: 130,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onGoodsCellChange(p)
        }, {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          colId: 'ourCompanyNo',
          field: 'ourCompanyNo',
          width: 130,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onGoodsCellChange(p)
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          colId: 'numberOfPieces',
          field: 'numberOfPieces',
          width: 100,
          valueFormatter: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: { min: 0, precision: 0 }
          },
          onCellValueChanged: p => this.onGoodsCellChange(p)
        }, {
          headerName: this.$t('SeaExport.Weight'),
          colId: 'grossWeight',
          field: 'grossWeight',
          width: 100,
          valueFormatter: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: { min: 0, precision: 0 }
          },
          onCellValueChanged: p => this.onGoodsCellChange(p)
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          colId: 'volume',
          field: 'volume',
          width: 100,
          valueFormatter: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: { min: 0, precision: 0 }
          },
          onCellValueChanged: p => this.onGoodsCellChange(p)
        }, {
          headerName: this.$t('SeaExport.Package'),
          colId: 'packing',
          field: 'packing',
          width: 100,
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Packing,
              filterable: true,
              tagValue: 'code'
            }
          },
          valueFormatter: params => {
            return ColumnUtils.packingCodeLabelFun(params.value)
          },
          onCellValueChanged: p => this.onGoodsCellChange(p)
        }, {
          headerName: this.$t('Payment.remarks'),
          colId: 'notes',
          field: 'notes',
          width: 130,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onGoodsCellChange(p)
        }
      ]
    }
  },
  watch: {
    details(val, oldVal) {
      if (val.resultJson !== oldVal.resultJson) {
        this.init()
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.smartTrustChannel = cache.config.get('SmartTrustChannel')
    await this.init()
  },
  methods: {
    handleFocus(val) {
      this.$emit('fieldFocus', val)
    },
    async init() {
      this.resultJson = JSON.parse(this.details.resultJson)
      // 将json信息转换成对应的值
      if (!this.resultJson.jobJson) {
        this.resultJson.jobJson = deepClone(this.initJob)
      }
      this.job = this.resultJson.jobJson
      this.goods.rowData = this.resultJson.goodList || []
      await this.initOcrSet()
      this.convertSft()
      this.convertMapper()
      this.initOther()
    },
    initOther() {
      getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
        for (const item of data) {
          if (item.blType === BlModeType.HBL.code) {
            const blMode = this.blModeList.find(p => p.uuid === item.uuid)
            if (!blMode) {
              this.blModeList.push(item)
            }
          }
        }
      })
    },
    convertMapper() {
      this.initMapper()
      // 委托单位
      if (!this.job.customerId || Number(this.job.customerId) <= 0) {
        this.mapperClient()
      }
      // 整箱拼箱
      if (StrUtils.isEmpty(this.job.containerLoadType) && !StrUtils.isEmpty(this.resultJson.fclOrLcl)) {
        this.mapperLoadType()
      }
      // 船公司
      if (!this.job.carrierId || Number(this.job.carrierId) <= 0) {
        this.mapperShipName()
      }
      // 开航日期
      if (StrUtils.isEmpty(this.job.etd) && !StrUtils.isEmpty(this.resultJson.etd)) {
        this.mapperEtd()
      }
      // 运输条款
      if (StrUtils.isEmpty(this.job.freightTerm) && !StrUtils.isEmpty(this.resultJson.serviceTerm)) {
        this.mapperFreightTerm()
      }
      // 运费条款
      if (StrUtils.isEmpty(this.job.incoTerm) && !StrUtils.isEmpty(this.resultJson.paymenTerm)) {
        this.mapperPaymentTerm()
      }
      // 贸易条款
      if (StrUtils.isEmpty(this.job.incoTerm) && !StrUtils.isEmpty(this.resultJson.deliveryTerm)) {
        this.mapperIncoTerm()
      }
      // 起运港
      if (StrUtils.isEmpty(this.job.loadingPortCode) && !StrUtils.isEmpty(this.resultJson.portOfLoading)) {
        this.mapperSeaPort('loadingPortCode', 'portOfLoading')
      }
      // 中转港
      if (StrUtils.isEmpty(this.job.transferPortCode) && !StrUtils.isEmpty(this.resultJson.transitPort)) {
        this.mapperSeaPort('transferPortCode', 'transitPort')
      }
      // 卸货港
      if (StrUtils.isEmpty(this.job.dischargingPortCode) && !StrUtils.isEmpty(this.resultJson.portOfDischarge)) {
        this.mapperSeaPort('dischargingPortCode', 'portOfDischarge')
      }
      // 交货地
      if (StrUtils.isEmpty(this.job.destinationPortCode) && !StrUtils.isEmpty(this.resultJson.placeOfDelivery)) {
        this.mapperSeaPort('destinationPortCode', 'placeOfDelivery')
      }
      // 包装
      if (StrUtils.isEmpty(this.job.packing) && !StrUtils.isEmpty(this.resultJson.packing)) {
        this.mapperPacking()
      }
      // 提单形式
      if (StrUtils.isEmpty(this.job.orderType) && !StrUtils.isEmpty(this.resultJson.orderType)) {
        this.mapperBlType()
      }
    },
    // 转换收发通地址
    convertSft() {
      if (this.job.shipperLine1 || this.job.consigneeLine1 || this.job.notifyLine1) return
      const shipper = this.resultJson.shipper
      const consignee = this.resultJson.consignee
      const notifyParty = this.resultJson.notifyParty
      for (let i = 1; i < 8; i++) {
        this.job[`shipperLine${i}`] = ''
        this.job[`consigneeLine${i}`] = ''
        this.job[`notifyLine${i}`] = ''
        this.splitSft(shipper, 'shipperLine')
        this.splitSft(consignee, 'consigneeLine')
        this.splitSft(notifyParty, 'notifyLine')
      }
    },
    splitSft(oldVal, type) {
      if (oldVal) {
        const oldValArr = oldVal.split('\n')
        const line7Arr = []
        for (let j = 0; j < oldValArr.length; j++) {
          if (j < 7) {
            this.job[type + `${j + 1}`] = oldValArr[j] ? oldValArr[j] : ''
            continue
          }
          line7Arr.push(oldValArr[j])
        }
        if (line7Arr.length > 0) {
          this.job[type + '7'] = line7Arr.join(',')
        }
      }
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      this.advanceTextDialog.visible = false
    },
    // 获取OCR映射
    async initOcrSet() {
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        anyInteger: 0, // 应用场景 0海运出口托书识别
        anyBool: true // 应用场景 判断是否应用总部
      }
      await getOcrList(params).then(res => {
        const ocrSet = res.data
        if (ocrSet) {
          // 文字映射
          this.toMapperText(ocrSet)
          // 额外录单字段
          this.toOtherField(ocrSet)
        }
      })
    },
    // 文字映射
    toMapperText(ocrSet) {
      const mapperList = ocrSet.mapperList || []
      const mapperHqList = ocrSet.mapperHqList || []
      const otherMapper = mapperList.length > 0 ? mapperList[0] : null
      if (otherMapper && otherMapper.ifHq) {
        this.mapperTexts = mapperHqList
      }
      if (!this.mapperTexts || this.mapperTexts.length === 0) {
        this.mapperTexts = mapperList || []
      }
    },
    initMapper() {
      this.port = new Map()
      this.carrier = new Map()
      this.blType = new Map()
      this.loadType = new Map()
      this.shippingTerm = new Map()
      this.paymentTerm = new Map()
      this.incoTerm = new Map()
      this.eq = new Map()
      this.customer = new Map()
      this.packing = new Map()
      const mapperTexts = this.mapperTexts
      if (!mapperTexts || mapperTexts.length <= 0) {
        return
      }
      for (const mapperText of this.mapperTexts) {
        const mapperKey = mapperText.type + '_' + mapperText.useCase + '_' + mapperText.oldText
        const mapperVal = mapperText.newText
        if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PORT.code) {
          this.port.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_CARRIER.code) {
          this.carrier.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_BL_TYPE.code) {
          this.blType.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_LOAD_TYPE.code) {
          this.loadType.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_SHIPPING_TERM.code) {
          this.shippingTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PAYMENT_TERM.code) {
          this.paymentTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_INCO_TERM.code) {
          this.incoTerm.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_EQ.code) {
          this.eq.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_CUSTOMER.code) {
          this.customer.set(mapperKey, mapperVal)
        } else if (mapperText.type === SystemConstants.OCR_MAPPER_TYPE_PACKING.code) {
          this.packing.set(mapperKey, mapperVal)
        }
      }
    },
    // 额外录单字段
    toOtherField(ocrSet) {
      const fieldList = ocrSet.fieldList || []
      const fieldHqList = ocrSet.fieldHqList || []
      const otherField = fieldList.length > 0 ? fieldList[0] : null
      let tempField = null
      if (otherField && otherField.ifHq) {
        tempField = fieldHqList.length > 0 ? fieldHqList[0] : null
      }
      if (!tempField) tempField = otherField
      if (!tempField) return
      const pattern = tempField.useField
      if (!pattern) {
        return
      }
      const expressList = []
      let index = -1
      for (let i = 0; i < pattern.length; ++i) {
        if (pattern[i] === '$' && pattern[i + 1] === '{') {
          index = i
          continue
        }
        if (pattern[i] === '}' && index > -1) {
          const name = pattern.substring(index + 2, i)
          const value = true
          expressList.push({ name, value })
          index = -1
        }
      }
      /* 表达式关联表单数据 */
      for (const item of expressList) {
        this.otherField[item.name] = !!item.value
      }
      this.$logger.log('expressList========', expressList)
      this.expressList = expressList
    },
    // ============================================多单模式========================================================
    // 点击多单模式
    onMultDoc() {
      this.showGoods = true
      this.job.showGoods = true
      const goodsList = this.goods.rowData
      if (goodsList && goodsList.length > 0) {
        for (const goods of goodsList) {
          if (!StrUtils.isEmpty(goods.packing)) {
            const packingCode = this.mapperPacking(goods.packing)
            if (packingCode) {
              goods.packing = packingCode
            }
          }
        }
        if (this.goods.gridApi) this.goods.gridApi.refreshCells({ force: true })
      }
    },
    addGoods() {
      const goods = {
        'grossWeight': 0,
        'numberOfPieces': 0,
        'volume': 0,
        'packing': '',
        'ourCompanyNo': '',
        'warehouseReceiptNo': '',
        'notes': ''
      }
      this.goods.rowData.splice(0, 0, goods)
      this.goods.gridApi.refreshCells({ force: true })
    },
    deleteGoods() {
      if (!this.goods.selectedRow) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }
      const goodsList = this.goods.rowData
      if (goodsList && goodsList.length > 0) {
        const index = goodsList.indexOf(this.goods.selectedRow)
        if (index > -1) {
          this.goods.rowData.splice(index, 1)
          this.goods.gridApi.refreshCells({ force: true })
          this.goods.gridApi.clearFocusedCell()
          this.goods.selectedRow = null
        }
      }
    },
    // 单号互换
    noExchange() {
      const goodsList = this.goods.rowData
      if (goodsList && goodsList.length > 0) {
        for (const goods of goodsList) {
          const ourCompanyNo = goods.ourCompanyNo
          goods.ourCompanyNo = goods.warehouseReceiptNo
          goods.warehouseReceiptNo = ourCompanyNo
        }
        this.goods.gridApi.refreshCells({ force: true })
      }
    },
    // 返回一单模式
    updateMode() {
      this.showGoods = false
      this.job.showGoods = false
    },
    // 货物列表更改
    onGoodsCellChange() {

    },
    // 委托单位
    mapperClient() {
      if (!StrUtils.isEmpty(this.resultJson.client)) {
        // 用解析值 匹配 代码
        let customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cnShortName', this.resultJson.client, 'cmpIdx')
        if (!customerId) {
          // 用解析值 匹配 英文名
          customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'englishName', this.resultJson.client, 'cmpIdx')
          if (!customerId || Number(customerId) <= 0) {
            // 用解析值 匹配 中文名
            customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'chineseName', this.resultJson.client, 'cmpIdx')
            if (!customerId || Number(customerId) <= 0) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_CUSTOMER.code + '_' + this.useCase + '_' + this.resultJson.client
              const newMapperVal = this.customer.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cnShortName', newMapperVal, 'cmpIdx')
                if (!customerId || Number(customerId) <= 0) {
                  // 用映射值 匹配 英文名
                  customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'englishName', newMapperVal, 'cmpIdx')
                  if (!customerId || Number(customerId) <= 0) {
                    // 用映射值 匹配 中文名
                    customerId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'chineseName', newMapperVal, 'cmpIdx')
                  }
                }
              }
            }
          }
        }
        this.job.customerId = customerId || 0
      }
    },
    // 船公司
    mapperShipName() {
      if (!StrUtils.isEmpty(this.resultJson.shipName)) {
        // 用解析值 匹配 代码
        let carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cnShortName', this.resultJson.shipName, 'cmpIdx')
        if (!carrierId) {
          // 用解析值 匹配 英文名
          carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'englishName', this.resultJson.shipName, 'cmpIdx')
          if (!carrierId || Number(carrierId) <= 0) {
            // 用解析值 匹配 中文名
            carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'chineseName', this.resultJson.shipName, 'cmpIdx')
            if (!carrierId || Number(carrierId) <= 0) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_CARRIER.code + '_' + this.useCase + '_' + this.resultJson.shipName
              const newMapperVal = this.carrier.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cnShortName', newMapperVal, 'cmpIdx')
                if (!carrierId || Number(carrierId) <= 0) {
                  // 用映射值 匹配 英文名
                  carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'englishName', newMapperVal, 'cmpIdx')
                  if (!carrierId || Number(carrierId) <= 0) {
                    // 用映射值 匹配 中文名
                    carrierId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'chineseName', newMapperVal, 'cmpIdx')
                  }
                }
              }
            }
          }
        }
        this.job.carrierId = carrierId || 0
      }
    },
    mapperEtd() {
      if (this.resultJson.etd) {
        let etd = DateUtils.toDateStr(this.resultJson.etd)
        if (!etd && this.resultJson.etd.length > 8) {
          etd = ColumnUtils.dateTimeLabelFunc(this.resultJson.etd)
        }
        this.job.etd = etd || ''
      }
    },
    // 整箱拼箱
    mapperLoadType() {
      if (!StrUtils.isEmpty(this.resultJson.fclOrLcl)) {
        // 用解析值 匹配 代码
        let loadType = ContainerLoadType.getContainerLoadTypeByCode(this.resultJson.fclOrLcl)
        let loadTypeCode = loadType ? loadType.code : ''
        if (!loadTypeCode) {
          // 用解析值 匹配 中英文名
          loadType = ContainerLoadType.getContainerLoadTypeByName(this.resultJson.fclOrLcl)
          loadTypeCode = loadType ? loadType.code : ''
          if (!loadTypeCode) {
            const mapperKey = SystemConstants.OCR_MAPPER_TYPE_LOAD_TYPE.code + '_' + this.useCase + '_' + this.resultJson.fclOrLcl
            const newMapperVal = this.loadType.get(mapperKey)
            if (newMapperVal) {
              // 用映射值 匹配 代码
              loadType = ContainerLoadType.getContainerLoadTypeByCode(newMapperVal)
              loadTypeCode = loadType ? loadType.code : ''
              if (!loadTypeCode) {
                // 用映射值 匹配 中英文名
                loadType = ContainerLoadType.getContainerLoadTypeByName(newMapperVal)
                loadTypeCode = loadType ? loadType.code : ''
              }
            }
          }
        }
        this.job.containerLoadType = loadTypeCode || ''
      }
    },
    // 运输条款
    mapperFreightTerm() {
      if (!StrUtils.isEmpty(this.resultJson.serviceTerm)) {
        // 用解析值 匹配 代码
        let freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'code', this.resultJson.serviceTerm, 'code')
        if (!freightTerm) {
          // 用解析值 匹配 英文名
          freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'name', this.resultJson.serviceTerm, 'code')
          if (!freightTerm) {
            // 用解析值 匹配 中文名
            freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'localName', this.resultJson.serviceTerm, 'code')
            if (!freightTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_SHIPPING_TERM.code + '_' + this.useCase + '_' + this.resultJson.serviceTerm
              const newMapperVal = this.shippingTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'code', newMapperVal, 'code')
                if (!freightTerm) {
                  // 用映射值 匹配 英文名
                  freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'name', newMapperVal, 'code')
                  if (!freightTerm) {
                    // 用映射值 匹配 中文名
                    freightTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ShippingTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        this.job.freightTermHBL = freightTerm || ''
        this.job.freightTerm = freightTerm || ''
      }
    },
    // 运费条款
    mapperPaymentTerm() {
      if (!StrUtils.isEmpty(this.resultJson.paymenTerm)) {
        // 用解析值 匹配 代码
        let paymenTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentTerm, 'code', this.resultJson.paymenTerm, 'code')
        if (!paymenTerm) {
          // 用解析值 匹配 英文名
          paymenTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentTerm, 'name', this.resultJson.paymenTerm, 'code')
          if (!paymenTerm) {
            // 用解析值 匹配 中文名
            paymenTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentTerm, 'localName', this.resultJson.paymenTerm, 'code')
            if (!paymenTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PAYMENT_TERM.code + '_' + this.useCase + '_' + this.resultJson.paymenTerm
              const newMapperVal = this.paymentTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                paymenTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentTerm, 'code', newMapperVal, 'code')
                if (!paymenTerm) {
                  // 用映射值 匹配 英文名
                  paymenTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentTerm, 'name', newMapperVal, 'code')
                  if (!paymenTerm) {
                    // 用映射值 匹配 中文名
                    paymenTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        this.job.paymentTermHBL = paymenTerm || ''
        this.job.paymentTermMBL = paymenTerm || ''
      }
    },
    // 贸易条款
    mapperIncoTerm() {
      if (!StrUtils.isEmpty(this.resultJson.deliveryTerm)) {
        // 用解析值 匹配 代码
        let incoTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_IncoTerm, 'code', this.resultJson.deliveryTerm, 'code')
        if (!incoTerm) {
          // 用解析值 匹配 英文名
          incoTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_IncoTerm, 'name', this.resultJson.deliveryTerm, 'code')
          if (!incoTerm) {
            // 用解析值 匹配 中文名
            incoTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_IncoTerm, 'localName', this.resultJson.deliveryTerm, 'code')
            if (!incoTerm) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_INCO_TERM.code + '_' + this.useCase + '_' + this.resultJson.deliveryTerm
              const newMapperVal = this.incoTerm.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                incoTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_IncoTerm, 'code', newMapperVal, 'code')
                if (!incoTerm) {
                  // 用映射值 匹配 英文名
                  incoTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_IncoTerm, 'name', newMapperVal, 'code')
                  if (!incoTerm) {
                    // 用映射值 匹配 中文名
                    incoTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_IncoTerm, 'localName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        this.job.incoTerm = incoTerm || ''
      }
    },
    // 起运港 中转港 卸货港 交货地
    mapperSeaPort(code = '', jsonCode = '') {
      if (!code) return
      if (!this.resultJson[jsonCode]) return
      // 用解析值 匹配 代码
      let portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', this.resultJson[jsonCode], 'code')
      if (!portCode) {
        // 用解析值 匹配 英文名
        portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'englishName', this.resultJson[jsonCode], 'code')
        if (!portCode) {
          // 用解析值 匹配 中文名
          portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'chineseName', this.resultJson[jsonCode], 'code')
          if (!portCode) {
            const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PORT.code + '_' + this.useCase + '_' + this.resultJson[jsonCode]
            const newMapperVal = this.port.get(mapperKey)
            if (newMapperVal) {
              // 用映射值 匹配 代码
              portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', newMapperVal, 'code')
              if (!portCode) {
                // 用映射值 匹配 英文名
                portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'englishName', newMapperVal, 'code')
                if (!portCode) {
                  // 用映射值 匹配 中文名
                  portCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'chineseName', newMapperVal, 'code')
                }
              }
            }
          }
        }
      }
      this.job[code] = portCode || ''
    },
    // 包装
    mapperPacking(packingVal = '') {
      let realPacking = this.resultJson.packing
      if (packingVal) { // 多单模式时 packingVal 有值
        realPacking = packingVal
      }
      let packingCode = ''
      if (!StrUtils.isEmpty(realPacking)) {
        // 用解析值 匹配 代码
        packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', realPacking, 'code')
        if (!packingCode) {
          // 用解析值 匹配 英文名
          packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'name', realPacking, 'code')
          if (!packingCode) {
            // 用解析值 匹配 中文名
            packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'chineseName', realPacking, 'code')
            if (!packingCode) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PACKING.code + '_' + this.useCase + '_' + realPacking
              const newMapperVal = this.packing.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', newMapperVal, 'code')
                if (!packingCode) {
                  // 用映射值 匹配 英文名
                  packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'name', newMapperVal, 'code')
                  if (!packingCode) {
                    // 用映射值 匹配 中文名
                    packingCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'chineseName', newMapperVal, 'code')
                  }
                }
              }
            }
          }
        }
        if (!packingVal) { // 多单模式时 packingVal 有值
          this.job.packing = packingCode || ''
        }
      }
      return packingCode
    },
    // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
    mapperBlType() {
      if (!StrUtils.isEmpty(this.resultJson.orderType)) {
        let releaseType = 0
        const orderType = this.resultJson.orderType
        if (orderType === 'ORIGINAL') {
          releaseType = 1
        } else if (orderType === 'SURRENDERED') {
          releaseType = 2
        } else if (orderType === 'SEA WAYBILL') {
          releaseType = 3
        } else {
          releaseType = ColumnUtils.getBlModeSerialNumberByName(orderType)
        }
        if (releaseType) {
          const mapperKey = SystemConstants.OCR_MAPPER_TYPE_BL_TYPE.code + '_' + this.useCase + '_' + this.resultJson.orderType
          const newMapperVal = this.blType.get(mapperKey)
          if (newMapperVal) {
            // 用映射值 匹配 中英文名
            releaseType = ColumnUtils.getBlModeSerialNumberByName(newMapperVal)
          }
        }
        this.job.orderType = releaseType
        this.job.seaCargoDoc = [{
          docType: 'HBL',
          releaseType: releaseType || 1
        }]
      }
    },
    etdChange(value) {
      this.job.etd = value
    },
    // 保存时获取数据
    getSubmitData() {
      // 多单模式
      if (this.showGoods) {
        this.resultJson.goodList = this.goods.rowData
      }
      const result = this.resultJson
      result.jobJson = this.job
      return result
    },
    // 客服改变
    async csrChangeHandler(data) {
      const job = this.job
      job.csr = data.value
      job.csrDepartment = 0
      job.csrOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.$store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.csrOffice = office ? office.officeId : 0
              job.csrDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'csr')
          if (dep) {
            job.csrDepartment = dep.departmentId
            const office = await Office.getOfficeByUuid(dep.officeUuid)
            job.csrOffice = office ? office.officeId : 0
          }
        }
      }
    },
    // 单证改变
    async dcChangeHandler(data) {
      const job = this.job
      job.dc = data.value
      job.dcDepartment = 0
      job.dcOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.$store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.dcOffice = office ? office.officeId : 0
              job.dcDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'doc')
          job.dcDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.dcOffice = office ? office.officeId : 0
        }
      } else {
        job.dc = 0
        job.dcDepartment = 0
        job.dcOffice = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.result-form{
  padding: 10px;
  table{
    width: 100%;
    tr{
      td {
        border: 1px solid #DCDFE6;
        height: 30px;
        &.header {
          width: 70px;
          text-align: center;
        }
        .el-form-item{
          margin: 0!important;
          input{
            border:none!important;
          }
        }
        .mapperClass {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>
